<template>
  <q-card
    flat bordered
  >
    <q-card-section
        class="q-pa-sm row justify-between items-center text-white text-bold bg-primary"
    >
       Monthly Total
    </q-card-section>
    <q-separator />
    <q-card-section>
      <div class="row q-gutter-sm">
        <div class="col">
          <app-clock-card
            icon="schedule"
            class="shadow-8"
            color="white"
            label="TOTAL WORKED HOURS"
            :value="hoursFormatAsTimer(monthlyData.workHours)"
            iconColor="brand9"
            labelColor="brand9"
            valueColor="primary"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>

</template>
<script>
  import graphql from '@client/graphql';
  import AppClockCard from './clock-card';

  export default {
    name: 'AppClockMonthlyTotal',
    components: {
      AppClockCard
    },
    apollo: {
      monthlySummary: {
        query: graphql.queries.monthlySummary,
        watchLoading(isLoading) {
          this.isLoading = isLoading;
        },
        result(result) {
          this.monthlyData = result?.data?.monthlySummary;
        }
      }
    },
    data() {
      return {
        isLoading: false,
        monthlyData: {
          workHours: 0,
          breakHours: 0
        }
      };
    },
    methods: {
      hoursFormatAsTimer(hours) {
       return new Date(hours * 60 * 60 * 1000).toISOString().substring(11, 19);
      }
    }
  };
</script>
<style lang="scss">
</style>
